import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { Observable } from 'rxjs';
import { IncidentModel } from '../../../models';
import { CustomTypeService, SettingsService, SiteService, TenantService, Type3Service } from '../../../services';
import { IncidentTypeService } from '../../../services/incident-type.service';
import { IncidentService } from '../../../services/incident.service';
import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
@Component({
    selector: 'app-daily-report-edit',
    templateUrl: './daily-report-edit.component.html',
    styleUrls: ['../../layout/layout.component.scss', '../../layout/mobile.css'],
    animations: [
        trigger('slideIn', [
            state('*', style({ 'overflow-y': 'hidden', 'overflow-x': 'hidden' })),
            state('void', style({ 'overflow-y': 'hidden', 'overflow-x': 'hidden' })),
            transition('* => void', [
                style({ height: '*' }),
                animate(300, style({ height: 0 }))
            ]),
            transition('void => *', [
                style({ height: '0' }),
                animate(300, style({ height: '*' }))
            ])
        ])
    ]
})
export class DailyReportEditComponent implements OnInit {
    model: IncidentModel = new IncidentModel();
    isAdminOrUserEditor: boolean;
    sites: any;
    type1: string = "Type 1";
    type2: string = "Type 2";
    type3: string = "Type 3";
    customTypes: any[];
    incidenttypes: any;
    type3List: any[];
    SiteId: number;
    tenants: any[];
    isTenantRequired: boolean;

    constructor(private location: Location,
        private incidentService: IncidentService,
        private type3Service: Type3Service,
        private router: Router,
        private siteService: SiteService,
        private route: ActivatedRoute,
        private settingService: SettingsService,
        private customTypeService: CustomTypeService,
        private incidentTypeService: IncidentTypeService,
        private tenantService: TenantService,
        private toastr: ToastsManager) { }

    ngOnInit() {

        this.model.IncidentGuard = [];
        this.model.Type2Id = 0;
        this.model.Type1Id = 0;
        this.model.Type3Id = 0;
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.loadCustomTypes();
        this.loadIncidentTypes();
        this.loadType3();
        this.loadSetting();
        this.loadSites(currentUser.accountId);
        if (currentUser.role === 'admin') {
            this.isAdminOrUserEditor = true;
        }
        else if (currentUser.role === 'user') {
            this.isAdminOrUserEditor = false;
        }
        this.route.params.subscribe((params) => {
            const id = params['id'];
            if (id) {
                this.loadData(id);
                // this.isDetail = true;
            }
        });
    }

    loadIncidentTypes() {
        this.incidenttypes = [];
        var user = JSON.parse(localStorage.getItem('currentUser'));

        var SiteId = +localStorage.getItem('currentSiteId');
        this.incidentTypeService.getAllIncidentTypes(user.accountId, SiteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    // this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {

                this.incidenttypes = response.Data;
                // this.toastr.success(response.Message, "Success"); 
            });
    };

    loadTenant(tenantTypeId: number) {
        //  
        //this.loadingTenant = true;
        this.model.TenantId = 0;
        this.tenants = [];
        this.tenantService.getTenantByTenantTypeId(this.SiteId, tenantTypeId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {
                //this.loadingTenant = false;
                this.tenants = response.Data;
                // this.toastr.success(response.Message, "Success"); 
            });

    }

    type3Changed() {
        if (this.model.Type3Id != 0 && this.model != undefined && this.model.Type3Id != undefined) {
            this.type3Service.getType3(this.model.Type3Id).catch((err: any) => {
                return Observable.throw(err);
            })
                .finally(() => {
                    setTimeout(() => {
                        //this.showSpinner = false;
                    }, 1000);
                })
                .subscribe((response: any) => {

                    this.isTenantRequired = response.Data.IsTenantRequired;
                    //console.log(this.isTenantRequired);
                    this.loadTenant(response.Data.TenantTypeId);
                });
        } else {
            this.isTenantRequired = false;
        }
    };

    public navigateReturn() {
        //this.router.navigate([`mobile/loans/${this.model.Id}/return`]);
        this.location.back();
    }

    public loadType3() {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.type3List = [];
        this.SiteId = +localStorage.getItem('currentSiteId');
        this.type3Service.getAllType3(currentUser.accountId, this.SiteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    // this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {

                this.type3List = response.Data;

                // this.toastr.success(response.Message, "Success"); 
            });
    }
    loadCustomTypes() {
        this.customTypes = [];
        var user = JSON.parse(localStorage.getItem('currentUser'));
        var SiteId = +localStorage.getItem('currentSiteId');
        this.customTypeService.getAllCustomTypes(user.accountId, SiteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {

                this.customTypes = response.Data;
                console.log(this.customTypes);
                // this.toastr.success(response.Message, "Success"); 
            });
    };


    public loadData(id: number) {
        this.incidentService.getIncidentV2(id)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {
                // 
                this.model = response.Data;
                this.type3Changed();
            });
    }
    loadSetting() {
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));

        this.settingService.getValue("type1", currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.type1 = response.Data.Value;
                }
            });


        this.settingService.getValue("type2", currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.type2 = response.Data.Value;
                }
            });


        this.settingService.getValue("type3", currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.type3 = response.Data.Value;
                }

            });

    }
    loadSites(accountId: number) {

        this.siteService.getSitesByAccountList(accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {
                this.sites = response.Data;
                //  this.toastr.success(response.Message, "Success"); 
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/components/mobile/daily-report/daily-report-edit.component.ts